import { Collection, type TConstraints } from '@feathr/rachis';

import { TargetableClass } from './targetable.types';
import type { ITargetableBase } from './targetable_base';
import { TargetableBase } from './targetable_base';

/**
 * Interface for age demographic targetables
 */
export interface IAgeDemographicTargetable extends ITargetableBase {
  _cls: TargetableClass.age_demographic;
  age_category: string;
}

/**
 * AgeDemographicTargetable class for age demographic targetables
 */
export class AgeDemographicTargetable extends TargetableBase<IAgeDemographicTargetable> {
  public override className = 'Targetable.TradedeskAgeTargetable';

  public override getDefaults(): Partial<IAgeDemographicTargetable> {
    return {
      ...super.getDefaults(),
      _cls: TargetableClass.age_demographic,
    };
  }

  public override get constraints(): TConstraints<IAgeDemographicTargetable> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [TargetableClass.age_demographic],
      },
      age_category: {
        presence: {
          allowEmpty: false,
        },
      },
    };
  }
}

export class AgeDemographicTargetables extends Collection<AgeDemographicTargetable> {
  public getClassName(): string {
    return 'targetables';
  }

  public getModel(attributes: Partial<IAgeDemographicTargetable>): AgeDemographicTargetable {
    return new AgeDemographicTargetable(attributes);
  }

  // URL override - points to age_demographics endpoint
  public override url(): string {
    return `${super.url()}age_demographics`;
  }
}
